import { IController, IScope, ITimeoutService, translate } from 'angular';
import { inject, injectable } from '../../../../shared/utils/inject/inject';
import { ISlugify } from '../../services/filters/slugify/slugify.filter';
import { IHeightCalc } from '../../services/heightCalc/heightCalc.factory';
import { IBiService } from '../../services/wix/biService';
import { ISettings, IWixBinding } from '../../services/wix/wixBinding';

@injectable
export class HorizontalRowController implements IController {
  public showDetails: boolean = false;
  public event: any;
  @inject private wixBinding: IWixBinding;
  @inject private heightCalc: IHeightCalc;
  @inject private $scope: IScope;
  @inject private $timeout: ITimeoutService;
  @inject private biService: IBiService;
  @inject private $translate: translate.ITranslateService;
  @inject private slugifyFilter: ISlugify;
  private settings: ISettings;

  get hasOffers() {
    return this.event.offers && this.event.offers.length > 0;
  }

  $onInit(): void {
    this.settings = this.wixBinding.getSettings();
  }

  notifyMeBI() {
    this.biService.sendButtonEvent(this.settings.name, 'Notify Me');
  }

  rsvpBI() {
    this.biService.rsvp(this.settings.name);
  }

  openButtonUrl(offer) {
    if (offer.type === 'Tickets') {
      this.biService.tickets(this.settings.name);
      return;
    }

    this.biService.sendButtonEvent(this.settings.name, offer.type);
  }
}
